import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Box, Tooltip, Link } from '@mui/material'

import { TableUrlPagination } from '../../../../ui'
import { STUCK_TABLE_COLUMNS } from '../../constants'
import { stuckDataPreparation } from '../../logics'
import { SendToZeusCheckbox } from './send-to-zeus-checkbox.component'

const getLookup = (combo) => {
  let lookup = {}
  combo.forEach((item) => (lookup[item.key] = item.value))
  return lookup
}

export const StuckTable = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const stuckLoader = useSelector((state) => state.loader.stuck)
  const combos = useSelector((state) => state.combos)

  const data = stuckLoader?.data?.solicitudes || []
  const totalEntries = stuckLoader?.data?.total_solicitudes
  const search = stuckLoader?.config?.params
  const loading = stuckLoader?.loading

  const formattedColumns = useMemo(() => {
    return STUCK_TABLE_COLUMNS.map((column) => {
      const baseColumn = {
        accessorKey: column.field,
        header: formatMessage({ id: `pages.stuck.table.columns.${column.field}.title` }),
        size: column.width,
        minSize: column.width,
        maxSize: column.width,
      }

      if (column.field === 'pez') {
        return {
          ...baseColumn,
          header: 'Envío programado',
          Cell: (props) => <SendToZeusCheckbox {...props} />,
          muiTableBodyCellProps: { align: 'center' },
        }
      }

      if (column.field === 'solicitud_id') {
        return {
          ...baseColumn,
          Cell: ({ row, cell }) => (
            <Link
              href={`/applications/${row.original.id}`}
              sx={{ color: '#004a6b', textDecoration: 'none' }}
            >
              {cell.getValue()}
            </Link>
          ),
        }
      }

      if (column.field === 'descripcion') {
        return {
          ...baseColumn,
          Cell: ({ cell }) => {
            const description = cell.getValue() ?? ''
            const description_array = description.split('\\n')
            const tooltipContent = (
              <>
                Se han detectado los siguientes errores:
                <ul style={{ paddingLeft: '20px', margin: 0 }}>
                  {description_array.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )
            return (
              <Tooltip title={tooltipContent} placement="bottom-start" interactive>
                <Box
                  sx={{
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    padding: '0 1em 0 16px',
                  }}
                >
                  {description}
                </Box>
              </Tooltip>
            )
          },
        }
      }

      if (column.comboId && combos[column.comboId]?.data) {
        const lookup = getLookup(combos[column.comboId].data)
        return {
          ...baseColumn,
          Cell: ({ cell }) => {
            const value = cell.getValue()
            return <span>{lookup[value] ?? value ?? '--'}</span>
          },
        }
      }

      return {
        ...baseColumn,
        Cell: ({ cell }) => <span>{cell.getValue() ?? '--'}</span>,
      }
    })
  }, [combos, formatMessage])

  const processedData = useMemo(() => stuckDataPreparation(data, { intl }), [data, intl])

  const finalTableOptions = useMemo(
    () => ({
      toolbar: false,
      selection: false,
      draggable: false,
      fixedColumns: {
        right: 1,
      },
    }),
    []
  )

  return (
    <TableUrlPagination
      columns={formattedColumns}
      options={finalTableOptions}
      totalEntries={totalEntries}
      search={search}
      data={processedData}
      isLoading={loading}
    />
  )
}
